import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";

import { type ICampaignVoucher } from "@types";

export const CAMPAIGN_VOUCHER_API_REDUCER_KEY = "campaignVoucherApi";
// Deliberately a plain fetchBaseQuery (no auth): voucher validation runs on the
// public campaign landing page before the visitor is authenticated, and the
// backend endpoint is unguarded. The timeout bounds how long the landing page
// can sit on its loading spinner if the backend hangs.
export const campaignVoucherApi = createApi({
  reducerPath: CAMPAIGN_VOUCHER_API_REDUCER_KEY,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl(), timeout: 10_000 }),
  endpoints: (builder) => ({
    // Resolves with the campaign info when the voucher is valid; a voucher that
    // is inactive or unknown rejects with a 404.
    getCampaignVoucher: builder.query<ICampaignVoucher, { voucherCode: string }>({
      query: ({ voucherCode }) => ({
        url: `/shopify/campaign-voucher/voucher/${encodeURIComponent(voucherCode)}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCampaignVoucherQuery } = campaignVoucherApi;
